export enum SituacaoSACEnum {
    NOVO = "Novo",
    EM_ANDAMENTO = "Em Andamento",
    FINALIZADO = "Finalizado"
}